import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

import fvImg1 from "../../image/top-fv2.JPG"

const TopFv = () => {

   return (
      <TopFvStyles fvImg1={fvImg1} >
         <div className="fv-box">
            <p className="join-us" >新規入塾生<br/>募集中</p>
            <div className="circle-box">
               <div className="circle">
                  <p className="catch1">圧倒的<br/>最安値</p>
               </div>
               <div className="circle">
                  <p className="catch2"><span>2019年度</span><br/>第一志望<br/>全員合格</p>
               </div>
            </div>
         </div>
      </TopFvStyles>
   )
}

const TopFvStyles = styled.section`
      position: relative;
      width: 100%;
      height: 96vh;
      background-image: url(${({fvImg1}) => fvImg1});
      background-size: cover;
      ${media.lessThan("600px")`
         background-position: 50%;
      `}

      .fv-box {
         position: absolute;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         height: 56%;
         top: 50%;
         left: 10%;
         transform: translate(0, -50%);
         .join-us {
            color: #fff;
            font-size: 6rem;
            font-weight: bold;
            letter-spacing: 1.5rem;
            text-shadow: 3px 3px 6px #000;
            line-height: 10rem;
            ${media.lessThan("600px")`
               font-size: 4rem;
               letter-spacing: 0rem;
               line-height: 6rem;
            `}
         }
         .circle-box {
            display: flex;
            justify-content: space-between;
            ${media.lessThan("600px")`
               flex-direction: column;
            `}
            .circle {
               width: 180px;
               height: 180px;
               border-radius: 50%;
               background-color: #FFFFFFCC;
               display: flex;
               align-items: center;
               ${media.lessThan("600px")`
                  width: 100px;
                  height: 100px;
                  &:last-child {
                     margin-top: 10px;
                  }
               `}
               p {
                  width: 100%;
                  text-align: center;
                  color: #FF3D01;
                  font-weight: bold;
               }
               .catch1 {
                  font-size: 4.3rem;
                  line-height: 50px;
                  ${media.lessThan("600px")`
                     font-size: 2rem;
                     line-height: 30px;
                  `}
               }
               .catch2 {
                  font-size: 3.2rem;
                  margin-bottom: 10px;
                  line-height: 4rem;
                  ${media.lessThan("600px")`
                     font-size: 2rem;
                     line-height: 2.2rem;
                  `}
                  span {
                     font-size: 2.6rem;
                     ${media.lessThan("600px")`
                        font-size: 1.4rem;
                     `}
                  }
               }
            }
         }
      }
`

export default TopFv